/**
 * Generated by orval v8.22.0 🍺
 * Do not edit manually.
 * Reflex API
 * OpenAPI spec version: 1.0.0
 */
import {
  useMutation,
  useQuery
} from '@tanstack/react-query';
import type {
  MutationFunction,
  QueryFunction,
  QueryKey,
  UseMutationOptions,
  UseMutationResult,
  UseQueryOptions,
  UseQueryResult
} from '@tanstack/react-query';

import type {
  BillingEntityDomainClaim
} from './model/billingEntityDomainClaim.js';

import type {
  Company
} from './model/company.js';

import type {
  CreateCompanyDomainClaimBody
} from './model/createCompanyDomainClaimBody.js';

import type {
  CreateCompanyOrganizationRequest
} from './model/createCompanyOrganizationRequest.js';

import type {
  ErrorEnvelope
} from './model/errorEnvelope.js';

import type {
  ListCompanyDomainClaims200
} from './model/listCompanyDomainClaims200.js';

import type {
  ListEnterpriseIdentityAuditEvents200
} from './model/listEnterpriseIdentityAuditEvents200.js';

import type {
  Organization
} from './model/organization.js';

import type {
  RemoveCompanyDomainClaim200
} from './model/removeCompanyDomainClaim200.js';

import type {
  UpdateCompanyDomainClaimPolicyBody
} from './model/updateCompanyDomainClaimPolicyBody.js';

import type {
  VerifyCompanyDomainClaim200
} from './model/verifyCompanyDomainClaim200.js';

import { apiFetch } from '../react-mutator.js';



type SecondParameter<T extends (...args: never) => unknown> = Parameters<T>[1];



const withQueryKey = <T extends object, K>(query: T, queryKey: K): T & { queryKey: K } => {
  const result = { queryKey } as T & { queryKey: K };
  for (const key of Object.keys(query)) {
    // The explicit queryKey always wins, matching the previous
    // `{ ...query, queryKey }` spread where it was set last.
    if (key === 'queryKey') continue;
    Object.defineProperty(result, key, {
      enumerable: true,
      configurable: true,
      get: () => (query as Record<string, unknown>)[key],
    });
  }
  return result;
};

/**
 * @summary Get the company that owns the active organization.
 */
export const getCompany = (

 options?: SecondParameter<typeof apiFetch>,signal?: AbortSignal
) => {


      return apiFetch<Company>(
      {url: `/company`, method: 'GET', signal
    },
      options);
    }




export const getGetCompanyQueryKey = () => {
    return [
    `/company`
    ] as const;
    }


export const getGetCompanyQueryOptions = <TData = Awaited<ReturnType<typeof getCompany>>, TError = unknown>( options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getCompany>>, TError, TData>, request?: SecondParameter<typeof apiFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetCompanyQueryKey();



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getCompany>>> = ({ signal }) => getCompany(requestOptions, signal);





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getCompany>>, TError, TData> & { queryKey: QueryKey }
}

export type GetCompanyQueryResult = NonNullable<Awaited<ReturnType<typeof getCompany>>>
export type GetCompanyQueryError = unknown


/**
 * @summary Get the company that owns the active organization.
 */

export function useGetCompany<TData = Awaited<ReturnType<typeof getCompany>>, TError = unknown>(
  options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getCompany>>, TError, TData>, request?: SecondParameter<typeof apiFetch>}

 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getGetCompanyQueryOptions(options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  return withQueryKey(query, queryOptions.queryKey);
}






/**
 * @summary List the active organization's company-owned email-domain claims.
 */
export const listCompanyDomainClaims = (

 options?: SecondParameter<typeof apiFetch>,signal?: AbortSignal
) => {


      return apiFetch<ListCompanyDomainClaims200>(
      {url: `/company/domains`, method: 'GET', signal
    },
      options);
    }




export const getListCompanyDomainClaimsQueryKey = () => {
    return [
    `/company/domains`
    ] as const;
    }


export const getListCompanyDomainClaimsQueryOptions = <TData = Awaited<ReturnType<typeof listCompanyDomainClaims>>, TError = unknown>( options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof listCompanyDomainClaims>>, TError, TData>, request?: SecondParameter<typeof apiFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getListCompanyDomainClaimsQueryKey();



    const queryFn: QueryFunction<Awaited<ReturnType<typeof listCompanyDomainClaims>>> = ({ signal }) => listCompanyDomainClaims(requestOptions, signal);





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof listCompanyDomainClaims>>, TError, TData> & { queryKey: QueryKey }
}

export type ListCompanyDomainClaimsQueryResult = NonNullable<Awaited<ReturnType<typeof listCompanyDomainClaims>>>
export type ListCompanyDomainClaimsQueryError = unknown


/**
 * @summary List the active organization's company-owned email-domain claims.
 */

export function useListCompanyDomainClaims<TData = Awaited<ReturnType<typeof listCompanyDomainClaims>>, TError = unknown>(
  options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof listCompanyDomainClaims>>, TError, TData>, request?: SecondParameter<typeof apiFetch>}

 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getListCompanyDomainClaimsQueryOptions(options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  return withQueryKey(query, queryOptions.queryKey);
}






/**
 * @summary Claim an email domain and get its DNS TXT challenge.
 */
export const createCompanyDomainClaim = (
    createCompanyDomainClaimBody: CreateCompanyDomainClaimBody,
 options?: SecondParameter<typeof apiFetch>,signal?: AbortSignal
) => {


      return apiFetch<BillingEntityDomainClaim>(
      {url: `/company/domains`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: createCompanyDomainClaimBody, signal
    },
      options);
    }




export const getCreateCompanyDomainClaimMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createCompanyDomainClaim>>, TError,{data: CreateCompanyDomainClaimBody}, TContext>, request?: SecondParameter<typeof apiFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof createCompanyDomainClaim>>, TError,{data: CreateCompanyDomainClaimBody}, TContext> => {

const mutationKey = ['createCompanyDomainClaim'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof createCompanyDomainClaim>>, {data: CreateCompanyDomainClaimBody}> = (props) => {
          const {data} = props ?? {};

          return  createCompanyDomainClaim(data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type CreateCompanyDomainClaimMutationResult = NonNullable<Awaited<ReturnType<typeof createCompanyDomainClaim>>>
    export type CreateCompanyDomainClaimMutationBody = CreateCompanyDomainClaimBody
    export type CreateCompanyDomainClaimMutationError = unknown

    /**
 * @summary Claim an email domain and get its DNS TXT challenge.
 */
export const useCreateCompanyDomainClaim = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createCompanyDomainClaim>>, TError,{data: CreateCompanyDomainClaimBody}, TContext>, request?: SecondParameter<typeof apiFetch>}
 ): UseMutationResult<
        Awaited<ReturnType<typeof createCompanyDomainClaim>>,
        TError,
        {data: CreateCompanyDomainClaimBody},
        TContext
      > => {
      return useMutation(getCreateCompanyDomainClaimMutationOptions(options));
    }
    /**
 * @summary Choose how verified proof is consumed (SSO discovery, auto-join destination).
 */
export const updateCompanyDomainClaimPolicy = (
    claimId: string,
    updateCompanyDomainClaimPolicyBody: UpdateCompanyDomainClaimPolicyBody,
 options?: SecondParameter<typeof apiFetch>,signal?: AbortSignal
) => {


      return apiFetch<BillingEntityDomainClaim>(
      {url: `/company/domains/${encodeURIComponent(String(claimId))}`, method: 'PATCH',
      headers: {'Content-Type': 'application/json', },
      data: updateCompanyDomainClaimPolicyBody, signal
    },
      options);
    }




export const getUpdateCompanyDomainClaimPolicyMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof updateCompanyDomainClaimPolicy>>, TError,{claimId: string;data: UpdateCompanyDomainClaimPolicyBody}, TContext>, request?: SecondParameter<typeof apiFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof updateCompanyDomainClaimPolicy>>, TError,{claimId: string;data: UpdateCompanyDomainClaimPolicyBody}, TContext> => {

const mutationKey = ['updateCompanyDomainClaimPolicy'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof updateCompanyDomainClaimPolicy>>, {claimId: string;data: UpdateCompanyDomainClaimPolicyBody}> = (props) => {
          const {claimId,data} = props ?? {};

          return  updateCompanyDomainClaimPolicy(claimId,data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type UpdateCompanyDomainClaimPolicyMutationResult = NonNullable<Awaited<ReturnType<typeof updateCompanyDomainClaimPolicy>>>
    export type UpdateCompanyDomainClaimPolicyMutationBody = UpdateCompanyDomainClaimPolicyBody
    export type UpdateCompanyDomainClaimPolicyMutationError = unknown

    /**
 * @summary Choose how verified proof is consumed (SSO discovery, auto-join destination).
 */
export const useUpdateCompanyDomainClaimPolicy = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof updateCompanyDomainClaimPolicy>>, TError,{claimId: string;data: UpdateCompanyDomainClaimPolicyBody}, TContext>, request?: SecondParameter<typeof apiFetch>}
 ): UseMutationResult<
        Awaited<ReturnType<typeof updateCompanyDomainClaimPolicy>>,
        TError,
        {claimId: string;data: UpdateCompanyDomainClaimPolicyBody},
        TContext
      > => {
      return useMutation(getUpdateCompanyDomainClaimPolicyMutationOptions(options));
    }
    /**
 * @summary Remove an email-domain claim.
 */
export const removeCompanyDomainClaim = (
    claimId: string,
 options?: SecondParameter<typeof apiFetch>,signal?: AbortSignal
) => {


      return apiFetch<RemoveCompanyDomainClaim200>(
      {url: `/company/domains/${encodeURIComponent(String(claimId))}`, method: 'DELETE', signal
    },
      options);
    }




export const getRemoveCompanyDomainClaimMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof removeCompanyDomainClaim>>, TError,{claimId: string}, TContext>, request?: SecondParameter<typeof apiFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof removeCompanyDomainClaim>>, TError,{claimId: string}, TContext> => {

const mutationKey = ['removeCompanyDomainClaim'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof removeCompanyDomainClaim>>, {claimId: string}> = (props) => {
          const {claimId} = props ?? {};

          return  removeCompanyDomainClaim(claimId,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type RemoveCompanyDomainClaimMutationResult = NonNullable<Awaited<ReturnType<typeof removeCompanyDomainClaim>>>

    export type RemoveCompanyDomainClaimMutationError = unknown

    /**
 * @summary Remove an email-domain claim.
 */
export const useRemoveCompanyDomainClaim = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof removeCompanyDomainClaim>>, TError,{claimId: string}, TContext>, request?: SecondParameter<typeof apiFetch>}
 ): UseMutationResult<
        Awaited<ReturnType<typeof removeCompanyDomainClaim>>,
        TError,
        {claimId: string},
        TContext
      > => {
      return useMutation(getRemoveCompanyDomainClaimMutationOptions(options));
    }
    /**
 * @summary Check DNS for the TXT challenge now.
 */
export const verifyCompanyDomainClaim = (
    claimId: string,
 options?: SecondParameter<typeof apiFetch>,signal?: AbortSignal
) => {


      return apiFetch<VerifyCompanyDomainClaim200>(
      {url: `/company/domains/${encodeURIComponent(String(claimId))}/verify`, method: 'POST', signal
    },
      options);
    }




export const getVerifyCompanyDomainClaimMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof verifyCompanyDomainClaim>>, TError,{claimId: string}, TContext>, request?: SecondParameter<typeof apiFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof verifyCompanyDomainClaim>>, TError,{claimId: string}, TContext> => {

const mutationKey = ['verifyCompanyDomainClaim'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof verifyCompanyDomainClaim>>, {claimId: string}> = (props) => {
          const {claimId} = props ?? {};

          return  verifyCompanyDomainClaim(claimId,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type VerifyCompanyDomainClaimMutationResult = NonNullable<Awaited<ReturnType<typeof verifyCompanyDomainClaim>>>

    export type VerifyCompanyDomainClaimMutationError = unknown

    /**
 * @summary Check DNS for the TXT challenge now.
 */
export const useVerifyCompanyDomainClaim = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof verifyCompanyDomainClaim>>, TError,{claimId: string}, TContext>, request?: SecondParameter<typeof apiFetch>}
 ): UseMutationResult<
        Awaited<ReturnType<typeof verifyCompanyDomainClaim>>,
        TError,
        {claimId: string},
        TContext
      > => {
      return useMutation(getVerifyCompanyDomainClaimMutationOptions(options));
    }
    /**
 * @summary List the company's enterprise identity audit events.
 */
export const listEnterpriseIdentityAuditEvents = (

 options?: SecondParameter<typeof apiFetch>,signal?: AbortSignal
) => {


      return apiFetch<ListEnterpriseIdentityAuditEvents200>(
      {url: `/company/enterprise-identity/audit`, method: 'GET', signal
    },
      options);
    }




export const getListEnterpriseIdentityAuditEventsQueryKey = () => {
    return [
    `/company/enterprise-identity/audit`
    ] as const;
    }


export const getListEnterpriseIdentityAuditEventsQueryOptions = <TData = Awaited<ReturnType<typeof listEnterpriseIdentityAuditEvents>>, TError = unknown>( options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof listEnterpriseIdentityAuditEvents>>, TError, TData>, request?: SecondParameter<typeof apiFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getListEnterpriseIdentityAuditEventsQueryKey();



    const queryFn: QueryFunction<Awaited<ReturnType<typeof listEnterpriseIdentityAuditEvents>>> = ({ signal }) => listEnterpriseIdentityAuditEvents(requestOptions, signal);





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof listEnterpriseIdentityAuditEvents>>, TError, TData> & { queryKey: QueryKey }
}

export type ListEnterpriseIdentityAuditEventsQueryResult = NonNullable<Awaited<ReturnType<typeof listEnterpriseIdentityAuditEvents>>>
export type ListEnterpriseIdentityAuditEventsQueryError = unknown


/**
 * @summary List the company's enterprise identity audit events.
 */

export function useListEnterpriseIdentityAuditEvents<TData = Awaited<ReturnType<typeof listEnterpriseIdentityAuditEvents>>, TError = unknown>(
  options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof listEnterpriseIdentityAuditEvents>>, TError, TData>, request?: SecondParameter<typeof apiFetch>}

 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getListEnterpriseIdentityAuditEventsQueryOptions(options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  return withQueryKey(query, queryOptions.queryKey);
}






/**
 * @summary Add an organization to the company that owns the active organization.
 */
export const createCompanyOrganization = (
    createCompanyOrganizationRequest: CreateCompanyOrganizationRequest,
 options?: SecondParameter<typeof apiFetch>,signal?: AbortSignal
) => {


      return apiFetch<Organization>(
      {url: `/company/organizations`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: createCompanyOrganizationRequest, signal
    },
      options);
    }




export const getCreateCompanyOrganizationMutationOptions = <TError = ErrorEnvelope,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createCompanyOrganization>>, TError,{data: CreateCompanyOrganizationRequest}, TContext>, request?: SecondParameter<typeof apiFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof createCompanyOrganization>>, TError,{data: CreateCompanyOrganizationRequest}, TContext> => {

const mutationKey = ['createCompanyOrganization'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof createCompanyOrganization>>, {data: CreateCompanyOrganizationRequest}> = (props) => {
          const {data} = props ?? {};

          return  createCompanyOrganization(data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type CreateCompanyOrganizationMutationResult = NonNullable<Awaited<ReturnType<typeof createCompanyOrganization>>>
    export type CreateCompanyOrganizationMutationBody = CreateCompanyOrganizationRequest
    export type CreateCompanyOrganizationMutationError = ErrorEnvelope

    /**
 * @summary Add an organization to the company that owns the active organization.
 */
export const useCreateCompanyOrganization = <TError = ErrorEnvelope,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createCompanyOrganization>>, TError,{data: CreateCompanyOrganizationRequest}, TContext>, request?: SecondParameter<typeof apiFetch>}
 ): UseMutationResult<
        Awaited<ReturnType<typeof createCompanyOrganization>>,
        TError,
        {data: CreateCompanyOrganizationRequest},
        TContext
      > => {
      return useMutation(getCreateCompanyOrganizationMutationOptions(options));
    }
